export const maskSeparation = (
  value,
  maxLength,
  separationLength,
  separator
) => {
  let newValue = value;
  newValue = newValue.replace(/\s/g, '');
  if (newValue.length > maxLength) {
    newValue = newValue.slice(0, maxLength);
  }
  const regexString = `(\\w{${separationLength}})(?=\\w)`;
  const regex = new RegExp(regexString, 'g');
  newValue = newValue.replace(regex, `$1${separator}`);
  return newValue;
};
